import type { ReactElement } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type {
    CommonGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import {
    OnboardingGoalQuestionType,
} from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

import { StyledWizardCardTextWrapper, StyledWizardGoalCard, StyledWizardGoalCardIconWrapper } from "./styles";

const iconsByType: Record<CommonGoalQuestionType, IconName> = {
    [OnboardingGoalQuestionType.FindNewProspects]: "search-keyword",
    [OnboardingGoalQuestionType.UploadListOfCompanies]: "list-icon-gradient",
    [OnboardingGoalQuestionType.EnrichCsvWithCompanies]: "refresh-gradient",
    [OnboardingGoalQuestionType.ConnectMyCrm]: "browser",
    [OnboardingGoalQuestionType.ResearchSpecificCompany]: "building",
};

interface Props {
    type: OnboardingGoalQuestionType;
    isActive?: boolean;
    onClick?: () => void;
}

const WizardGoalCard = ({ type, isActive, onClick }: Props): ReactElement => {
    return (
        <StyledWizardGoalCard
            className={isActive ? "activeCard" : ""}
            onClick={onClick}
        >
            <StyledWizardGoalCardIconWrapper>
                <SWReactIcons
                    className={iconsByType[type]}
                    iconName={iconsByType[type]}
                />
            </StyledWizardGoalCardIconWrapper>

            <I18n
                element={StyledWizardCardTextWrapper}
                translatable={{ key: `si.onboarding.wizard.goal-card-title.${type}` }}
            />
        </StyledWizardGoalCard>
    );
};

export default WizardGoalCard;
